import type { CMSColumn, CMSTabs } from '@/components/cms/schemas';

/**
 * Extracts unique FAQ IDs from CMS tabs data structure
 * @param tabsData - The CMS tabs data containing FAQ items
 * @returns An array of unique FAQ IDs, removing any duplicates that may exist across different tabs
 */
export const extractFaqIds = (tabsData: CMSTabs): string[] => {
  const ids = tabsData.items.flatMap((tab) =>
    tab.content
      .filter((content) => content.type === 'faqs')
      .flatMap((content) => content.items.map((item) => item.id))
  );

  return Array.from(new Set(ids));
};

// Extract ids from type article_card
export const extractArticleIds = (data: CMSColumn) => {
  const ids = data.items
    .filter((item) => item.type === 'article_card')
    .map((item) => item.content.id);

  return Array.from(new Set(ids));
};

export const hasAnyTabHeading = (tabsData: CMSTabs) =>
  tabsData.items.some((item) => item.tab_heading !== null);

export const generateGridOrder = ({
  itemOrder,
  isEnabled,
}: {
  itemOrder?: number;
  isEnabled: boolean;
}) => {
  if (!isEnabled || itemOrder == null) {
    return {};
  }

  return {
    order: itemOrder,
  };
};
